export { default as DefaultPage } from './DefaultPage';
export { default as AlogPage } from './AlogPage';


// WEBPACK FOOTER //
// ./src/features/alog/index.js